import {
  createDomainListReduxUtil,
  REDUX_STATUS
} from '@gymaholic/packages'
import setUtil from 'utils/set'
import { getObjectUtil } from 'packages/src'

function loadInstance (state, action) {
  const { path } = action.payload
  return setUtil(state, path, {
    ...getObjectUtil(state, path),
    error: null,
    validation: null,
    status: REDUX_STATUS.LOADING
  })
}

function loadDomain (state, action) {
  const { domainListPath } = action.payload
  const domainList = getObjectUtil(state, domainListPath) || createDomainListReduxUtil()
  return setUtil(state, domainListPath, {
    ...domainList,
    status: REDUX_STATUS.LOADING,
    error: null
  })
}

function loadReduxReducer (state, action) {
  const {
    path
  } = action.payload

  if (path) {
    return loadInstance(state, action)
  }

  return loadDomain(state, action)
}

export {
  loadReduxReducer
}
